module.exports = __webpack_public_path__ + "fonts/brand-icons.a046592b.a046592b.woff";